import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'indianCurrency',
    standalone: false
})
export class IndianCurrencyPipe implements PipeTransform {
    transform (value: number | string | null | undefined, addRupee?: boolean): string {
        const num = typeof value === 'string' ? parseFloat(value) : value;
        if (num === null || num === undefined || isNaN(num)) {
            return '0.00';
        }
        if (addRupee) {
            return '₹ ' + num.toLocaleString('en-IN', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            });
        }
        return num.toLocaleString('en-IN', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });
    }
}